export default {
  GET_TASK_BUBBLES: (state) => {
    return state.bubbles;
  },
  GET_SYNCHRONIZED_BUBBLES: (state) => {
    return state.synchronizedBubbles;
  },
};
